import {TrackingPageTypeWithoutId} from '@aboutyou/legacy-tracking-sdk';
import React, {FC} from 'react';
import styled from 'styled-components';
import {HelpCenterEndpoint} from '../../../pages/HelpCenter/helpCenterEndpoint';
import {
  HelpCenterPageCommonProps,
  HelpCenterSection,
} from '../../../pages/HelpCenter/types';
import {SharedPageTrackingContextProvider} from '../../../tracking/context/PageTrackingContext';
import {getPageContextProps} from '../../../tracking/hooks/trackingHelpers';
import BreadCrumbs from '../../Navigation/BreadCrumbs/BreadCrumbs';
import {darkGrayColor, primaryColor} from '../../constants/colors';
import {mediaMinTablet} from '../../constants/customMedia';
import {
  fsS,
  fsXL,
  fwHeavy,
  fwMediumBold,
  lhM,
} from '../../constants/typography';
import HelpdeskInnerPage from '../HelpdeskInnerPage/HelpdeskInnerPage';
import ContactForm, {CloudflareTurnstileType} from './ContactForm';

const Title = styled.h1`
  font-size: ${fsXL}px;
  ${fwHeavy};
  line-height: ${lhM};
  letter-spacing: 0.4px;
  color: ${primaryColor};
  margin-top: 10px;
  margin-bottom: 38px;
`;
const Description = styled.p`
  font-size: ${fsS}px;
  ${fwMediumBold};
  line-height: 1.81;
  color: ${darkGrayColor};
  margin: 0 0 32px;
`;
const SidePadding = styled.div`
  padding: 0 16px;
  @media ${mediaMinTablet} {
    padding: 0;
  }
`;

interface Props {
  locale: HelpCenterPageCommonProps['locale'];
  translations: HelpCenterPageCommonProps['translations'];
  sections: HelpCenterSection[];
  sendContactForm: HelpCenterEndpoint['sendContactForm'];
  isVip?: boolean;
  isProduction: boolean;
  endpoints: HelpCenterPageCommonProps['endpoints'];
  localizedServiceEmailAddress: string;
  isShowOldHelpCenterEnabled?: boolean;
  CloudflareTurnstile?: CloudflareTurnstileType;
}

const ContactPageUI: FC<Props> = props => {
  const pageContext = getPageContextProps(
    TrackingPageTypeWithoutId.HelpCenterContact,
  );
  return (
    <SharedPageTrackingContextProvider
      {...pageContext}
      type={TrackingPageTypeWithoutId.HelpCenterContact}
    >
      <HelpdeskInnerPage
        locale={props.locale}
        sections={props.sections}
        translations={props.translations}
        endpoints={props.endpoints}
        isShowOldHelpCenterEnabled={props.isShowOldHelpCenterEnabled}
      >
        <BreadCrumbs
          crumbs={[{label: props.translations.breadcrumb.help, url: '/h'}]}
          translations={props.translations.breadcrumb}
        />
        <SidePadding>
          <Title data-testid="HelpCenterArticlePageTitle">
            {props.translations.contactPage.heading}
          </Title>
          <Description>
            {props.translations.contactPage.description}
          </Description>
          <ContactForm
            isProduction={props.isProduction}
            localizedServiceEmailAddress={props.localizedServiceEmailAddress}
            sections={props.sections}
            sendContactForm={props.sendContactForm}
            translations={props.translations.contactPage.form}
            isVip={props.isVip}
            endpoints={props.endpoints}
            locale={props.locale}
            CloudflareTurnstile={props.CloudflareTurnstile}
          />
        </SidePadding>
      </HelpdeskInnerPage>
    </SharedPageTrackingContextProvider>
  );
};

export default ContactPageUI;
